import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface HistorialTodoRiesgo {
  id?: number;
  placa: string;
  aseguradora: string;
  fecha_expedicion: string;
  fecha_vencimiento: string;
  numero: string;
  estado?: number;
  estado_fechas?: string;
}

@Injectable({
  providedIn: 'root',
})
export class HistorialTodoRiesgoService {
  private apiUrl =  `${environment.apiUrl}/api/historial_todo_riesgo`; 
  //private readonly apiUrl = 'http://localhost:3000/api/historial_todo_riesgo';

  constructor(private http: HttpClient) {}

  /** Método para obtener headers con autenticación segura */
  private getSecureHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  /** Obtener todos los historiales */
  getAll(): Observable<{ historial: HistorialTodoRiesgo[] }> {
    return this.http.get<{ historial: HistorialTodoRiesgo[] }>(this.apiUrl, {
      headers: this.getSecureHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error('❌ Error al obtener historiales todo riesgo:', error);
        return throwError(() => new Error('Error al obtener historiales todo riesgo'));
      })
    );
  }

  /** Obtener historial por ID */
  getById(id: number): Observable<HistorialTodoRiesgo> {
    return this.http.get<HistorialTodoRiesgo>(`${this.apiUrl}/${id}`, {
      headers: this.getSecureHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error('❌ Error al obtener historial todo riesgo por ID:', error);
        return throwError(() => new Error('Error al obtener historial todo riesgo'));
      })
    );
  }

  /** Obtener historial por placa (corregido con prefijo) */
  getByPlaca(placa: string): Observable<HistorialTodoRiesgo[]> {
    return this.http.get<HistorialTodoRiesgo[]>(`${this.apiUrl}/placa/${placa}`, {
      headers: this.getSecureHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error('❌ Error al obtener historial todo riesgo por placa:', error);
        return throwError(() => new Error('Error al obtener historial todo riesgo por placa'));
      })
    );
  }

  /** Crear nuevo historial */
  create(data: HistorialTodoRiesgo): Observable<HistorialTodoRiesgo> {
    return this.http.post<HistorialTodoRiesgo>(this.apiUrl, data, {
      headers: this.getSecureHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error('❌ Error al crear historial todo riesgo:', error);
        return throwError(() => new Error('Error al crear historial todo riesgo'));
      })
    );
  }

  /** Actualizar historial por ID */
  update(id: number, data: Partial<HistorialTodoRiesgo>): Observable<HistorialTodoRiesgo> {
    return this.http.put<HistorialTodoRiesgo>(`${this.apiUrl}/${id}`, data, {
      headers: this.getSecureHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error('❌ Error al actualizar historial todo riesgo:', error);
        return throwError(() => new Error('Error al actualizar historial todo riesgo'));
      })
    );
  }

  /** Inactivar historial por ID */
  inactivarPorId(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/inactivar/${id}`, {}, {
      headers: this.getSecureHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error('❌ Error al inactivar historial todo riesgo:', error);
        return throwError(() => new Error('Error al inactivar historial todo riesgo'));
      })
    );
  }
}
